import { lazy } from 'react';
import { authRoles } from '@/app/auth';

const EditClientOrderPage = lazy(() => import('./EditClientOrderPage'));

const EditClientOrderConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.Orders,
  routes: [
    {
      path: 'orders/:id/edit',
      element: <EditClientOrderPage />,
    },
  ],
};

export default EditClientOrderConfig;
